import { mapCompanyVolume } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/companyVolume.utils';
import { companyVolumeApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Broker-facing read — a 403 (DEV-3647 broker-auth gap) must degrade to the empty
// state, never trigger the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

const COMPANY_VOLUME_WINDOW_DAYS = 90;

export const COMMAND_CENTER_COMPANY_VOLUME_ACTION_TYPE = createNamedActions(
  'commandCenterCompanyVolume',
  {
    SET_COMPANY_VOLUME: 'SET_COMPANY_VOLUME',
  },
);

export const getCompanyVolumeAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await companyVolumeApi.getFundedUnits({
    trailingWindowDays: COMPANY_VOLUME_WINDOW_DAYS,
    config: SKIP_FORBIDDEN_CONFIG,
  });

  return dispatch({
    type: COMMAND_CENTER_COMPANY_VOLUME_ACTION_TYPE.SET_COMPANY_VOLUME,
    payload: mapCompanyVolume(data ?? null),
  });
});
